import ApiManager from '../Api.manager'
import { FilterTypes } from '../../enum/Filter.enum'
import HttpConstants from '../../constants/HttpConstants'
import UrlConstants from '../../constants/UrlConstants'
import { getFiltersForApi } from '../../utils/FilterUtils'

//query
export const getAPIFilters = (payload: any) => {
  const usecase = UrlConstants.GET_API_FILTERS.USECASE
  const filters = getFiltersForApi(FilterTypes.API_MONITORING, payload)
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else throw response
      })
      .catch((error) => {
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const getAPIGroupFilters = (payload: any) => {
  const usecase = UrlConstants.GROUP_API_FILTERS.USECASE
  const filters = getFiltersForApi(FilterTypes.API_MONITORING, payload)
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else throw response
      })
      .catch((error) => {
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const getAPILogFilters = (payload: {
  id: string
  paramsWithDateRange: {
    'created-from': string
    'created-to': string
    'time-zone': string
  }
}) => {
  const usecase = UrlConstants.GROUP_API_LOG_FILTERS.USECASE
  const filters = {
    $id: payload.id,
    ...getFiltersForApi(FilterTypes.API_MONITORING, payload.paramsWithDateRange)
  }
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else throw response
      })
      .catch((error) => {
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const getAPIGroupUserFilters = (payload: {
  id: string
  paramsWithDateRange: {
    'created-from': string
    'created-to': string
    'time-zone': string
  }
}) => {
  const usecase = UrlConstants.GROUP_API_USER_FILTERS.USECASE

  const filters = {
    $id: payload.id,
    ...getFiltersForApi(FilterTypes.API_MONITORING, payload.paramsWithDateRange)
  }

  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else throw response
      })
      .catch((error) => {
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const getFiltersForGroupByUsers = (payload: {
  groupId: string
  userId: string
  paramsWithDateRange: {
    'created-from': string
    'created-to': string
    'time-zone': string
  }
}) => {
  const usecase = UrlConstants.GET_API_FILTER_FOR_GROUPS_BY_USER.USECASE
  const filters = {
    $groupId: payload.groupId,
    $userId: payload.userId,
    ...getFiltersForApi(FilterTypes.API_MONITORING, payload.paramsWithDateRange)
  }
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else throw response
      })
      .catch((error) => {
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}
export const downloadAPIGroupedURLView = (payload: any) => {
  const filters = getFiltersForApi(FilterTypes.API_MONITORING, payload)
  const usecase = UrlConstants.DOWNLOAD_API_GROUPED_URL_VIEW.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const downloadAPIGroupedUserView = (payload: any) => {
  const filters = getFiltersForApi(FilterTypes.API_MONITORING, payload)
  const usecase = UrlConstants.DOWNLOAD_API_GROUPED_USER_VIEW.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const downloadAllUrlView = (payload: any) => {
  const filters = getFiltersForApi(FilterTypes.API_MONITORING, payload)
  const usecase = UrlConstants.DOWNLOAD_ALL_API_URL_VIEW.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const findRecords = (queryParams: any) => {
  const filters = getFiltersForApi(FilterTypes.API_MONITORING, queryParams)
  const usecase = UrlConstants.FIND_API_MONITORING_RECORDS.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(error.data.message)
      })
  })
}

export const findRecordsForGroupByUser = (queryParams: any) => {
  const filters = getFiltersForApi(FilterTypes.API_MONITORING, queryParams)
  const usecase =
    UrlConstants.FIND_API_MONITORING_RECORDS_FOR_GROUP_BY_USER.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(error.data.message)
      })
  })
}

export const getApiUsersByURLGraph = (payload: any) => {
  const usecase = UrlConstants.GET_API_USERS_BY_GROUP_URL_GRAPH.USECASE
  const { apiGroupId, ...rest } = payload
  const filters = getFiltersForApi(FilterTypes.API_MONITORING, rest)

  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      { ...filters, $apiGroupId: apiGroupId }
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(error.data.message)
      })
  })
}

export const getApiByURLWeeklyLogs = (payload: any) => {
  const usecase = UrlConstants.GET_GRAPH_DATA_BY_API_GROUP_ID.USECASE
  const { id, ...rest } = payload
  const filters = getFiltersForApi(FilterTypes.API_MONITORING, rest)

  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      { ...filters, $id: id }
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(error.data.message)
      })
  })
}

export const getApiByWeeklyUserLogs = (payload: any) => {
  const usecase = UrlConstants.GET_GRAPH_DATA_BY_API_USER_ID.USECASE
  const { id, ...rest } = payload
  const filters = getFiltersForApi(FilterTypes.API_MONITORING, rest)

  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      { ...filters, $id: id }
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(error.data.message)
      })
  })
}

export const groupedUserFilterData = (queryParams: any) => {
  const filters = getFiltersForApi(FilterTypes.API_MONITORING, queryParams)
  const usecase = UrlConstants.GET_API_GROUPED_FILTER_BY_ID.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(error.data.message)
      })
  })
}

export const fetchGroupedApiRecords = (queryParams: any) => {
  const filters = getFiltersForApi(FilterTypes.API_MONITORING, queryParams)
  const usecase = UrlConstants.FETCH_API_GROUPED_RECORD.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const fetchGroupedApiUserRecords = (queryParams: any) => {
  const filters = getFiltersForApi(FilterTypes.API_MONITORING, queryParams)
  const usecase = UrlConstants.GET_API_GROUPED_USER_VIEW.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const fetchHeaderGroupedData = (payload: { $id: string }) => {
  const usecase = UrlConstants.FETCH_API_GROUPED_RECORD_WITH_ID.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      payload
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(error.data.message)
      })
  })
}

export const getGroupsByApiUserId = (payload: any) => {
  const usecase = UrlConstants.GET_API_GROUPS_BY_API_USER_ID.USECASE
  const { id, ...rest } = payload
  const filters = getFiltersForApi(FilterTypes.API_MONITORING, rest)

  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      { ...filters, $id: id }
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(error.data.message)
      })
  })
}

export const getApiUserById = (payload: { $id: string }) => {
  const usecase = UrlConstants.GET_API_USER_BY_ID.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      payload
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(error.data.message)
      })
  })
}

//query
export const findRecord = (payload: { $id: string }) => {
  const usecase = UrlConstants.FIND_API_MONITORING_RECORD.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      payload
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const findPayloadRecord = (payload: { $id: string }) => {
  const usecase = UrlConstants.FIND_API_MONITORING_PAYLOAD_RECORD.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      payload,
      {disableEncryption: false}
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const deleteRecord = (payload: { $id: string }) => {
  const usecase = UrlConstants.DELETE_API_MONITORING_RECORD.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.DELETE_METHOD,
      payload
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(error.data.message)
      })
  })
}

export const softDeleteRecord = (payload: { $id: string }) => {
  const usecase = UrlConstants.SOFT_DELETE_API_MONITORING_RECORD.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.DELETE_METHOD,
      payload
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(error.data.message)
      })
  })
}

export const restoreRecord = (payload: { $id: string }) => {
  const usecase = UrlConstants.RESTORE_API_MONITORING_RECORD.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.PATCH_METHOD,
      payload
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(error.data.message)
      })
  })
}
